import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { OperationsController } from './operations.controller';
import { OperationsService } from './operations.service';
import { Operations } from './operations.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { OperationsAdapter } from './dto/operations.adapter';
import { VariantOperationsModule } from '../variant-operations/variant-operations.module';
import { VariantOperationRepository } from '../variant-operations/repository/variant-operation.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';

@Module({
  imports: [
    TypeOrmModule.forFeature([Operations]),VariantOperationsModule
  ],
  controllers: [OperationsController],
  providers: [OperationsService,OperationsAdapter,ApplicationExceptionHandler,LogsService,WhatsAppNotificationService,WhatsappBroadCastService]
})
export class OperationsModule {}
